import LockerTypeAvailabilityJson from './interfaces/LockerTypeAvailabilityJson'

export default class LockerTypeAvailability {
  lockerTypeId: string
  available: boolean

  constructor(lockerTypeId: string, available: boolean) {
    this.lockerTypeId = lockerTypeId
    this.available = available
  }

  static fromJson(data: LockerTypeAvailabilityJson) {
    return new this(data.lockerTypeId, data.available)
  }
}
